$shm_hitalama_map_widget_page $shm_hitalama_page
	resize_side \left
	Map_page $shm_hitalama_map_page
	widget $shm_hitalama_map_widget
	head /
		<= Title $mol_string_button
			value? <=> title? \
	Tools $shm_hitalama_map_widget_tools
		widget <= widget
		Map_page <= Map_page
		Up => Up
		Down => Down
		Lock => Lock
		Fullscreen => Fullscreen
		Delete => Delete
		code_widget_tool_visible => code_widget_tool_visible
		settings_tool_visible /
	Contextmenu $shm_hitalama_map_widget_contextmenu
		widget <= widget
		Map_page <= Map_page
		Customize => Customize
		Make_extension => Make_extension
		Quick_access => Quick_access
		To_front => To_front
		To_back => To_back
	opacity_percent_options /number
		10
		25
		50
		75
		100
	body /
		<= Tool_icons $mol_view
			sub <= tools /
				<= Up
				<= Down
				^ code_widget_tool_visible
				<= Lock
				<= Fullscreen
				- <= Delete
		<= Z_jump $mol_view
			sub /
				<= To_front
				<= To_back
		<= Size_section $mol_view
			sub /
				<= Xw_row $mol_view
					sub /
						<= X_label $mol_paragraph
							title \X
						<= X $mol_number
							value? <=> x? 0
							Dec null
							Inc null
						<= Width_label $mol_paragraph
							title \W
						<= Width $mol_number
							value? <=> widget_width? 0
							Dec null
							Inc null
				<= Yh_row $mol_view
					sub /
						<= Y_label $mol_paragraph
							title \Y
						<= Y $mol_number
							value? <=> y? 0
							Dec null
							Inc null
						<= Height_label $mol_paragraph
							title \H
						<= Height $mol_number
							value? <=> height? 0
							Dec null
							Inc null
				<= Z_row $mol_view
					sub /
						<= Z_label $mol_paragraph
							title \Z
						<= Z $mol_number
							value? <=> z? 0
							Dec null
							Inc null
						<= Auto_height $mol_check_box
							title \Автовысота
							checked? <=> auto_height? false
		<= Font_section $mol_view
			sub /
				<= Font_row $mol_view
					sub /
						<= Font_size_labeler $mol_labeler
							title \Размер
							content / <= Font_size $shm_hitalama_map_fontsize
								font_size? <=> font_size? 14
						<= Font_family_labeler $mol_labeler
							title \Шрифт
							content / <= Font_family $mol_string
								value? <=> font_family? \
								hint \system-ui, 'Segoe UI', Tahoma
				<= Font_color_labeler $mol_labeler
					title \Цвет текста
					content /
						<= Font_color $shm_hitalama_color_pick
							color? <=> color? \var(--mol_theme_text)
							color_default \var(--mol_theme_text)
						<= Font_color_hex $mol_string
							value? <=> color? \var(--mol_theme_text)
		<= Background_section $mol_view
			sub /
				<= Background_labeler $mol_labeler
					title \Фон
					content /
						<= Background_color $shm_hitalama_color_pick
							color? <=> background_color? \
							color_default <= background_color_default \transparent
						<= Background_hex $mol_string
							value? <=> background_color? \
						<= Background_opacity_wrap $mol_view
							sub /
								<= Background_opacity_search $mol_search
									query? <=> background_opacity_percent_selected? \
									anchor_content /
										<= Background_opacity $mol_number
											value? <=> background_opacity_percent? 100
											Dec null
											Inc null
									suggests <= opacity_percent_suggests /string
		<= Border_section $mol_view
			sub /
				<= Border_labeler $mol_labeler
					title \Обводка
					content /
						<= Border_color $shm_hitalama_color_pick
							color? <=> border_color? \var(--mol_theme_text)
							color_default \var(--mol_theme_text)
						<= Border_hex $mol_string
							value? <=> border_color? \var(--mol_theme_text)
						<= Border_width $shm_hitalama_map_borderwidth
							border_width? <=> border_width? 1
						<= Border_style $mol_select
							value? <=> border_style? \solid
							Filter null
							trigger_content <= border_style_content /
								<= Border_style_current $mol_view
									sub /
										<= Border_style_current_line $mol_view
											style *
												borderBottomStyle <= border_style \solid
								<= Border_style_current_none $mol_icon_close
							option_content* <= border_style_option_content* /
								<= Border_style_option* $mol_view
									sub /
										<= Border_style_option_line* $mol_view
											style *
												borderBottomStyle <= border_style_option* \solid
								<= Border_style_none $mol_icon_close
							options /
								\none
								\solid
								\dashed
								\dotted
						<= Border_opacity_wrap $mol_view
							sub /
								<= Border_opacity_search $mol_search
									query? <=> border_opacity_percent_selected? \
									anchor_content /
										<= Border_opacity $mol_number
											value? <=> border_opacity_percent? 100
											Dec null
											Inc null
									suggests <= opacity_percent_suggests /string
		^ text_visible /
			<= Text_labeler $mol_labeler
				label /
					\Текст
					<= Text_copy $mol_button_copy
						hint \Копировать текст
						text <= text \
						sub /
							<= Text_copy_icon $mol_icon_content_copy
				content /
					<= Text_scroll $mol_scroll
						sub /
							<= Text $mol_textarea
								value? <=> text? \
		<= Data_section $mol_view
			sub /
				<= Data_title $mol_paragraph
					title \Data
				<= Data_list $mol_list
					sub <= data_rows /
		^ type_settings_visible /
			<= Type_settings $mol_list
				sub <= type_settings /
		<= Hide_head_tools $mol_check_box
			title \Скрыть панель над виджетом
			checked? <=> hide_head_tools? false
		<= Customize
		<= Make_extension
		<= Quick_access
	Data_labeler* $mol_labeler
		title <= data_key* \
		content /
			<= Data_value* $mol_textarea
				value? <=> data_value_text*? \
